/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import { Typography } from "@mui/material";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";

const SizeSoftXFooter = () => {
    const { theme } = useConfiguracion();
    return (
        <div
            style={{
                height: 40,
                backgroundColor: theme.palette.secondary.main,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Typography variant="caption" color="white">
                &copy; {new Date().getFullYear()} | SizeSoftX
            </Typography>
        </div>
    );
};

export default SizeSoftXFooter;
